import { useParams, useSearchParams } from "react-router-dom";
import { useCourses } from "../hooks/useCourses";

import Alerts from "@/components/Alerts";
import CourseCard from "./CourseCard";
import PageSkeleton from "./PageSkeleton";
import Pagination from "@/components/Pagination";
import FilterButtons from "@/components/FilterButtons";

export function CoursesSection({ filterButtons }) {
    const { school_level ,grade } = useParams();
    const [searchParams] = useSearchParams();

    // API Operations
    const filter = [{ field: "grade", value: grade },{ field: "school_level", value: school_level }];
    // Extracting filter parameters from the URL
    const filterType = searchParams.get("filter[type]");

    // Update the filter array based on the URL parameters
    if (filterType) {
        filter.push({ field: "type", value: filterType });
    }
    const include = [
        { field: "VideosDuration", value: "true" },
        { field: "VideosCount", value: "true" },
        { field: "QuizzesCount", value: "true" },
        { field: "StudentsCount", value: "true" },
    ];

    const page = searchParams.get("page")
        ? parseInt(searchParams.get("page"), 10) < 1
            ? 1
            : parseInt(searchParams.get("page"), 10)
        : 1;

    //number of items will display in screen
    const perPage = 3;

    //Get Data From The API
    const { isPending, courses } = useCourses({filter, include, page, perPage});

    const totalPages = Math.ceil(courses?.meta.total / courses?.meta.per_page);

    return (
        <section className="container flex flex-col items-center justify-center px-2 mx-auto text-sm transition-all md:px-16 md:pb-14 md:text-lg">
            <h2 className="self-start text-2xl md:text-4xl pt-14 text-secondary-color">
                الفصول <span className="text-secondary-color ">الدراسية </span>
            </h2>
            <div className="py-4">
                <FilterButtons filters={filterButtons} haveAll={true} />
            </div>
            <div className="w-full">
                {isPending && <PageSkeleton />}
                {courses?.data?.map((course) => (
                    <CourseCard course={course} key={course?.id} />
                ))}
                {!courses?.data?.length && !isPending ? (
                    <Alerts
                        variant={"filled"}
                        severity={"error"}
                        message={"لا يوجد محاضرات"}
                    />
                ) : null}
            </div>
            {totalPages > 1 && !isPending ? (
                <Pagination
                    className="mt-5"
                    total={totalPages}
                    paginationKey="page"
                />
            ) : null}
        </section>
    );
}
